import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * Enganche de la tienda con el ciclo de sesión, para que esta librería no dependa del carrito.
 * `capturar` se llama ANTES de autenticar (aún está la sesión de invitado) y su resultado se pasa a `adoptar`
 * una vez iniciada la sesión real; `adoptar` devuelve los avisos de lo que no pudo pasar (ítems en conflicto).
 */
export interface CustomerSessionListener {
  capturar?(): unknown;
  adoptar?(captura: unknown): Observable<string[]>;
  /** La sesión terminó o se perdió: la tienda limpia lo que era de esa persona (carrito en memoria). */
  alCerrarSesion?(): void;
}

export const CUSTOMER_SESSION_LISTENER = new InjectionToken<CustomerSessionListener>('CUSTOMER_SESSION_LISTENER');
